import styled from 'styled-components'

import { TextField, Props } from './TextField'

const TextArea = styled(TextField).attrs<Props>({
  multiline: true,
})``

export default TextArea
